module.exports = __webpack_public_path__ + "static/icona-b8d126d5638beb713db4c70819fe09b5.png";